import { useState, useEffect } from "react";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { toast } from "sonner";

export function ProfileDialog({ open, onClose }) {
  const { user, refresh } = useAuth();
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [address, setAddress] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    if (open && user) {
      setEmail(user.email || "");
      setPhone(user.phone || "");
      setAddress(user.address || "");
    }
  }, [open, user]);

  const save = async () => {
    setBusy(true);
    try {
      await api.put("/auth/profile", { email, phone, address });
      await refresh();
      toast.success("Profile updated");
      onClose();
    } catch (e) { toast.error(formatApiError(e.response?.data?.detail)); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="bg-brand-bg max-w-sm" data-testid="profile-dialog">
        <DialogHeader>
          <DialogTitle className="font-serif text-2xl tracking-tight text-left">My Profile</DialogTitle>
          <DialogDescription className="sr-only">Update your contact details</DialogDescription>
        </DialogHeader>
        <div className="space-y-3">
          <div className="space-y-1.5"><Label className="text-sm font-semibold">User ID</Label>
            <Input value={user?.username || ""} disabled className="border-brand-line font-mono bg-brand-line/20" data-testid="profile-username" /></div>
          <div className="space-y-1.5"><Label className="text-sm font-semibold">Email (optional)</Label>
            <Input type="email" autoCapitalize="none" autoCorrect="off" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="name@example.com" className="border-brand-line" data-testid="profile-email" /></div>
          <div className="space-y-1.5"><Label className="text-sm font-semibold">Phone</Label>
            <Input value={phone} onChange={(e) => setPhone(e.target.value)} className="border-brand-line" data-testid="profile-phone" /></div>
          <div className="space-y-1.5"><Label className="text-sm font-semibold">Address</Label>
            <Input value={address} onChange={(e) => setAddress(e.target.value)} className="border-brand-line" data-testid="profile-address" /></div>
        </div>
        <DialogFooter><Button onClick={save} disabled={busy} data-testid="profile-save" className="bg-brand-primary hover:bg-brand-primary-hover text-white rounded-sm w-full">Save Profile</Button></DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
